import React, { useEffect, useState } from 'react';
import { hueFromId, initialsFromName } from '../api/agents';

/** Strip the trailing /api so relatively-stored photo paths still resolve. */
const API_ORIGIN = (
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api'
).replace(/\/api\/?$/, '');

const resolve = (u: string): string =>
  /^https?:\/\//i.test(u) ? u : `${API_ORIGIN}${u.startsWith('/') ? '' : '/'}${u}`;

interface AvatarProps {
  /** Profile photo URL; falls back to coloured initials when missing or broken. */
  src?: string | null;
  name: string;
  /** Seeds the fallback colour so a person keeps the same colour everywhere. */
  id: number;
  size: number;
  radius?: number;
  fontSize?: number;
}

const Avatar: React.FC<AvatarProps> = ({ src, name, id, size, radius = 10, fontSize }) => {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [src]);

  const box: React.CSSProperties = { width: size, height: size, borderRadius: radius, flexShrink: 0 };

  if (src && !broken) {
    return (
      <img
        src={resolve(src)}
        alt={name}
        onError={() => setBroken(true)}
        style={{ ...box, objectFit: 'cover', background: 'var(--g100)' }}
      />
    );
  }

  const hue = hueFromId(id);
  return (
    <div
      className="flex items-center justify-center font-bold"
      style={{
        ...box,
        fontSize: fontSize ?? Math.round(size * 0.38),
        background: `hsl(${hue}, 60%, 92%)`,
        color: `hsl(${hue}, 50%, 40%)`,
      }}
    >
      {initialsFromName(name || '?')}
    </div>
  );
};

export default Avatar;
